import { useState } from 'react';

const useSuggestionInput = (elementHeight: number) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const increaseListIndex = (num: number) => {
    setSelectedIndex(s => s + num);
  };

  const scrollUp = (scrollContainer: HTMLDivElement, listLength: number) => {
    const tmpContainer = scrollContainer;
    if (listLength > 0 && tmpContainer) {
      const topOffsetElements = Math.ceil(tmpContainer.scrollTop / elementHeight);
      if (selectedIndex === topOffsetElements) {
        tmpContainer.scrollTop = (topOffsetElements - 1) * elementHeight;
      }
    }
  };

  const scrollDown = (scrollContainer: HTMLDivElement, listLength: number) => {
    const tmpContainer = scrollContainer;
    if (listLength > 0 && tmpContainer) {
      const containerHeight = tmpContainer.offsetHeight;
      const maxFullContainElements = Math.floor(containerHeight / elementHeight);
      const splittedElementHeight = containerHeight % elementHeight;
      const needToScroll = elementHeight - splittedElementHeight;
      if (maxFullContainElements - 1 === selectedIndex) {
        tmpContainer.scrollTop = needToScroll;
      }
      if (maxFullContainElements - 1 < selectedIndex) {
        tmpContainer.scrollTop += elementHeight;
      }
    }
  };

  const onKeyPress = (
    event: React.KeyboardEvent<any>,
    listLength: number,
    handleSelectElement: (e: React.KeyboardEvent<any>) => void,
    scrollContainer: HTMLDivElement,
  ) => {
    switch (event.key) {
      case 'ArrowDown': {
        scrollDown(scrollContainer, listLength);
        if (selectedIndex === -1) {
          setSelectedIndex(0);
        } else if (selectedIndex < listLength - 1) {
          increaseListIndex(1);
        }
        break;
      }
      case 'ArrowUp': {
        scrollUp(scrollContainer, listLength);
        if (selectedIndex > 0) {
          increaseListIndex(-1);
        }
        break;
      }
      case 'Enter': {
        event.preventDefault();
        if (selectedIndex !== -1) {
          handleSelectElement(event);
          setSelectedIndex(-1);
        }
        break;
      }
      default:
        break;
    }
  };

  return {
    onKeyPress,
    selectedIndex,
  };
};

export default useSuggestionInput;
